import { fCurrency } from 'utils'

const IncomeActualsMontlyTotal = ({
    month,
    trackerEntries,
    filteredTrackers
}) => {
    function getEntryCellAmount() {
        let trackerIds = filteredTrackers.map((tracker, index) => tracker.id)

        let expenseEntries = trackerEntries.filter(
            (entry) =>
                entry.data.type == 'Income' &&
                trackerIds.includes(entry.data.trackerId) &&
                entry.data.month == month &&
                entry.data.actual == true
        )

        return expenseEntries?.reduce((previous, current) => {
            return previous + current.data.amount
        }, 0)
    }
    return <td className='text-success'>{fCurrency(getEntryCellAmount())}</td>
}

export default IncomeActualsMontlyTotal
